import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upsc-merchant-services',
  templateUrl: './merchant-services.component.html',
  styleUrls: ['./merchant-services.component.scss']
})
export class MerchantServicesComponent implements OnInit {

  ngOnInit(): void {
  }
}
